import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import { CartContext } from 'components/cart';
import truncateIt from 'text-clipper';
import { useSwipeable } from 'react-swipeable';
import Api from '../Api';
import classNames from 'lib/classNames';
import { API_GATEWAY } from 'aws-exports';

const cache = {};

const defaultAdditionalData = { images: [], body_html: '' };

const ProductDetails = ({ style }) => {
	const {
		previewed_product: product,
		cart_settings: {
			theme: { primary },
			product_details: settings_product_details,
			product: { sold_out },
			// : {
			// 	truncate,
			// 	truncate_length,
			// 	atcButton,
			// 	atcButton_background,
			// 	atcButton_hoverBackground,
			// 	readMore,
			// 	external,
			// },
			rtl,
		},
		add_to_cart,
		shop_url,
		Utils,
		slider: { slickGoTo, active_slide },
		scrollbars_ref,
		shopify_cart_items,
		productionAddToCart,
		isPreview,
		setVariantPickerOptions,
		setVariantsPickerShow,
		campaigns
	} = useContext(CartContext);
	const [canBeTruncated, setCanBeTruncated] = useState(true);
	const [fetchingAdditionalData, setFetchingAdditionalData] = useState(true);
	const [image_slider, setImage_slider] = useState(0);
	const [loading, setLoading] = useState(false);
	const [additionalData, setAdditionalData] = useState(defaultAdditionalData);
	const [isSoldOut, setIsSoldOut]  = useState(false)
	// console.log("campaigns")
	// console.log(campaigns)

	const {
		truncate,
		truncate_length,
		atcButton,
		atcButton_background,
		atcButton_hoverBackground,
		readMore,
		external,
	} =  (Object.values(campaigns).flat(Infinity).find(({type}) => type === "add_to_unlock") &&
	Object.values(campaigns).flat(Infinity).find(({type}) => type === "add_to_unlock")["add_to_unlock"]["product_details"] )|| settings_product_details
	// Object.values(campaigns).find(({ id }) => id)||
	window.m_show_more = () => {
		if (!external) setCanBeTruncated(false);
		else if (!isPreview) window.location.href = `${window.origin}/products/${product.handle}`;
	};
	const addToCart = (variant) => {
		if (isPreview) {
			return;
		}
		productionAddToCart(shopify_cart_items, { variant_id: variant.id }, () => {
			setVariantsPickerShow(false);
			slickGoTo(0);
			scrollbars_ref.scrollTop = 0;
		});
	};

	const addToCartInit = async () => {
		if (isPreview) return;
		setLoading(true);
		const { data } = await Api.get(`${API_GATEWAY}/public/products`, {
			params: {
				handle: product.handle,
				shop: shop_url,
			},
		});
		if (data.products && data.products.length) {
			
			const { variants, options, image, images } = data.products[0];
			const newProductData = { ...product, variants, options, image, images };
			const PRODUCT_HAS_ONLY_ONE_VARIANT = options.length === 1 && options[0].values.length === 1;
			const {inventory_quantity, inventory_policy, inventory_management } = variants[0]
			if (PRODUCT_HAS_ONLY_ONE_VARIANT ) 
			{ 
				setLoading(false);

				// allow out of stock selling
				if((inventory_quantity > 0 || inventory_management !== "shopify" || ( inventory_management === "shopify" && inventory_policy === "continue" ))){
					addToCart(variants[0]); 
				}else {
					setIsSoldOut(true)
				}
				
			} else {
				setLoading(false);
				setVariantPickerOptions({
					product: {
						...newProductData,
						variants: newProductData.variants.map(variant =>{
							return {
								image: (newProductData.images.find(({ id }) => id === variant.image_id) || {src:null}).src,
								...variant
							}
						})
					},
					buttonText: atcButton.text,
					onConfirm: (variant) => addToCart(variant),
				});
				setVariantsPickerShow(true);
			}
		}
		setLoading(false);
	};

	useEffect(() => {
		setCanBeTruncated(true);
	}, [truncate, truncate_length]);

	useEffect(() => {
		setIsSoldOut(false);
	}, [product]);

	useEffect(() => {
		if (scrollbars_ref) scrollbars_ref.scrollTop = 0;
		async function getProductAdditionalData() {
			setAdditionalData(defaultAdditionalData);
			const { data } = await Api.get(`${API_GATEWAY}/public/products`, {
				params: {
					handle: product.handle,
					shop: shop_url,
				},
			});

			if (data.products && data.products.length) {
				const { images, body_html } = data.products[0];
				setAdditionalData({ images, body_html });
				setFetchingAdditionalData(false);
			}
		}
		if (product) {
			if (!product.images || !product.body_html) {
				getProductAdditionalData();
			} else {
				const { images, body_html } = product;
				setAdditionalData({ images, body_html });
				setFetchingAdditionalData(false);
			}
		}
	}, [product]);

	const last = additionalData.images.length - 1;
	const prev = () => {
		const next = image_slider === 0 ? last : image_slider - 1;
		setImage_slider(next);
	};
	const next = () => {
		const next = image_slider === last ? 0 : image_slider + 1;
		setImage_slider(next);
	};

	const truncated_body_html = truncateIt(
		additionalData.body_html,
		truncate_length ? parseInt(truncate_length) : Infinity,
		{ html: true }
	);

	const get_body_html_length = (body_html) => {
		var container = document.createElement('div');
		container.innerHTML = body_html.trim();
		return container.textContent.length;
	};
	const handlers = useSwipeable({ onSwipedRight: () => slickGoTo(0) });
	return product ? (
		<div
			className={classNames('w-full min-w-full px-5 py-3')}
			id="monster_product_details"
			style={style}
			{...handlers}
		>
			<LazyContent loading={fetchingAdditionalData}>
				{() =>
					additionalData.images.length > 1 ? (
						<div className={classNames('relative slider w-full max-w-full overflow-hidden')}>
							<div
								className={classNames(
									'slider-container flex transition-transform duration-300 ease-out'
								)}
								style={{
									transform: `translateX(-${image_slider * 100}%)`,
								}}
							>
								{additionalData.images.map((image) => (
									<div
										className={classNames('w-full min-w-full z-0')}
										// style={{ height: 180 }}
										style={{ height: 300 }}
										key={image.id}
									>
										<div
											className={classNames('bg-cover bg-center w-full h-full')}
											style={{ backgroundImage: `url('${image.src}')` }}
										/>
									</div>
								))}
							</div>
							<span
								className={classNames('absolute z-10 flex left-0 ml-2 transform -translate-y-1/2')}
								style={{
									background: 'rgba(255,255,255,0.8)',
									borderRadius: '50%',
									top: 'calc(50% - 12px)',
								}}
							>
								<svg
									aria-hidden="true"
									focusable="false"
									data-icon="arrow-alt-circle-left"
									role="img"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 512 512"
									className={classNames('w-5 h-5')}
									style={{ color: 'rgba(0,0,0,0.8)' }}
									onClick={() => prev()}
								>
									<path
										fill="currentColor"
										d="M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
									></path>
								</svg>
							</span>
							<span
								className={classNames('absolute z-10 flex right-0 mr-2 transform -translate-y-1/2')}
								style={{
									background: 'rgba(255,255,255,0.8)',
									borderRadius: '50%',
									top: 'calc(50% - 12px)',
								}}
							>
								<svg
									aria-hidden="true"
									focusable="false"
									data-icon="arrow-alt-circle-right"
									role="img"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 512 512"
									className={classNames('w-5 h-5')}
									style={{ color: 'rgba(0,0,0,0.8)' }}
									onClick={() => next()}
								>
									<path
										fill="currentColor"
										d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
									></path>
								</svg>
							</span>
							<div className={classNames('flex-center py-2')}>
								{additionalData.images.map((_, key) => (
									<span
										className={classNames('w-2 h-2 rounded-full mx-1 cursor-pointer border')}
										style={{
											backgroundColor:
												image_slider === key && Utils.formatColor(atcButton_background),
											borderColor: Utils.formatColor(atcButton_background),
										}}
										key={key}
										onClick={() => setImage_slider(key)}
									></span>
								))}
							</div>
						</div>
					) : additionalData.images.length === 1 ? (
						<img className={classNames('w-full h-auto')} src={additionalData.images[0].src} />
					) : null
				}
			</LazyContent>

			<div className={classNames('py-3')}>
				<h3 className={classNames('font-bold mb-3')}>{product.title}</h3>
				{product.showAddCartButton && (
					<button
						style={{
							backgroundColor: Utils.formatColor(atcButton_background),
							color: Utils.formatColor(atcButton.color),
							fontSize: Utils.em(atcButton.font_size),
							width: '100%',
							'--hover-background': Utils.formatColor(atcButton_hoverBackground),
						}}
						className={classNames('custom-btn p-4 w-full relative', {
							'opacity-50 cursor-not-allowed': isSoldOut,
						})}
						onClick={() => addToCartInit()}
						disabled={isSoldOut}
					>
						<span
							className={classNames({
								'opacity-0': loading,
							})}
						>
							{isSoldOut ?sold_out  : atcButton.text}
						</span>
						<div className={classNames('absolute inset-0 flex-center', { hidden: !loading })}>
							<svg
								aria-hidden="true"
								focusable="false"
								data-icon="spinner-third"
								role="img"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 512 512"
								className={classNames('w-4 h-4 fa-spin')}
							>
								<path
									fill="currentColor"
									d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z"
								></path>
							</svg>
						</div>
					</button>
				)}

				<LazyContent loading={fetchingAdditionalData}>
					{() => (
						<>
							<p
								dangerouslySetInnerHTML={{
									__html:
										canBeTruncated && truncate
											? truncated_body_html +
											  `<div class='clear-both'><span onclick="m_show_more()" class='mu-cursor-pointer mu-font-bold hover:mu-underline ${
													rtl ? 'mu-float-left' : 'mu-float-right'
											  }' style="color:${Utils.formatColor(readMore.color)};font-size:${
													readMore.font_size
											  }em;display:${
													get_body_html_length(additionalData.body_html) <= truncate_length
														? 'none'
														: 'initial'
											  }">${readMore.text}</span></div>`
											: additionalData.body_html,
								}}
								className={classNames('py-2')}
							/>
						</>
					)}
				</LazyContent>
			</div>
		</div>
	) : null;
};

ProductDetails.propTypes = {};

const LazyContent = ({ loading, children }) => {
	const {
		cart_settings: {
			theme: { primary },
		},
		Utils,
	} = useContext(CartContext);

	return (
		<div className={classNames('relative', { 'p-4': loading })} style={{ minHeight: 60 }}>
			{loading ? <Spinner color={Utils.formatColor(primary)} /> : children()}
		</div>
	);
};

export default ProductDetails;
